module.exports = __webpack_public_path__ + "static/media/start.5b50f175.svg";